// src/components/VerifyEmail/VerifyEmailPrompt.jsx
// Prompt para verificar el email: ingresar el código de 6 dígitos que se envió al
// registrarse (o reenviarlo). Se auto-oculta si no hay email o si ya está verificado.
// Backend: POST /api/verify-email + /api/resend-verification (ambos autenticados).
import React, { useState } from 'react';
import { FiMail, FiCheckCircle } from 'react-icons/fi';
import { useAuth } from '../../Context/AuthContext';
import './VerifyEmailPrompt.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function VerifyEmailPrompt() {
  const { user, updateUser } = useAuth();
  const [code, setCode]     = useState('');
  const [loading, setLoad]  = useState(false);
  const [error, setError]   = useState('');
  const [info, setInfo]     = useState('');
  const [cooldown, setCd]   = useState(0);

  // Solo para cuentas con email sin verificar.
  if (!user?.email || user?.emailVerified) return null;

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo('');
    if (!/^\d{6}$/.test(code.trim())) { setError('El código son 6 dígitos.'); return; }
    setLoad(true);
    try {
      const res  = await fetch(`${API_URL}/api/verify-email`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body:    JSON.stringify({ code: code.trim() }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'Código inválido o vencido.');
      updateUser({ emailVerified: true });
    } catch (err) {
      setError(err.message === 'Failed to fetch' ? 'No se pudo conectar al servidor.' : err.message);
    } finally {
      setLoad(false);
    }
  };

  const resend = async () => {
    if (cooldown > 0) return;
    setError(''); setInfo('');
    try {
      const res = await fetch(`${API_URL}/api/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.message || 'No se pudo reenviar.');
      setInfo('Te reenviamos el código a tu email.');
      setCd(30);
      const t = setInterval(() => setCd(c => { if (c <= 1) { clearInterval(t); return 0; } return c - 1; }), 1000);
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="ve">
      <div className="ve-head">
        <span className="ve-ic"><FiMail /></span>
        <div>
          <h3 className="ve-title">Verificá tu email</h3>
          <p className="ve-sub">Te enviamos un código de 6 dígitos a <strong>{user.email}</strong>. Ingresalo para verificar tu cuenta.</p>
        </div>
      </div>
      <form className="ve-form" onSubmit={submit}>
        <input
          className="ve-input"
          placeholder="000000"
          inputMode="numeric"
          value={code}
          onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
          maxLength={6}
        />
        <button type="submit" className="ve-btn" disabled={loading}>
          {loading ? <span className="ve-spin" /> : <><FiCheckCircle /> Verificar</>}
        </button>
      </form>
      {error && <div className="ve-msg err">{error}</div>}
      {info  && <div className="ve-msg ok">{info}</div>}
      <button type="button" className="ve-resend" onClick={resend} disabled={cooldown > 0}>
        {cooldown > 0 ? `Reenviar código (${cooldown}s)` : '¿No te llegó? Reenviar código'}
      </button>
    </div>
  );
}
